import React, { useState, useEffect } from 'react'
import {
	DETAILS_APPLY_FOR,
	FORM_FIELDS,
	LOOSE_FORM_FIELDS,
	WEIGHT_UNIT_SELECT_ITEMS_WO_TON,
} from '../../constants'
import { Dropdown } from 'primereact/dropdown'
import {
	WEIGHT_UNIT_SELECT_ITEMS,
	DIMENSION_UNIT_SELECT_ITEMS,
	DIMENSION_UNIT,
} from '../../constants'
import {
	validateLineItemWeights,
	validateTotalWeight,
	validateLooseDetails,
} from '../SearchPanel/formUtils'
import trashIcon from '../../assets/images/trash.svg'
import { Button } from 'primereact/button'
import calculateKgWeight from '../../utils/calculateKgWeight'
import './loose-line-item.scss'
import ExportToExcel from './Content'
import ExcelReader from './LooseUpload'
import { calculateWeightToKg, round, allowNumberOnly } from '../../utils/common'
import { useTranslation } from 'react-i18next'
import infoIcon from '../../assets/images/info_icon.svg'
import CommonInput from '../../common/Resusable/CommonInput'
import RadioToggle from '../SearchPanel/RadioToggle'
import FileUpload from './FileUpload'
import plusIcon from '../../assets/images/plusBlue.svg';
import uploadIcon from '../../assets/images/uploadIcon.svg'
import deleteIcon from "../../assets/images/delete_icon_red.png";
import { CommonDropDown } from '../../common/Resusable/CommonDropDown'



const LooseLineItem = ({
	looseDetails,
	setLooseDetails,
	totalWeight,
	setTotalWeight,
	setLooseItemsGrossWeight,
	weightUnit,
	setWeightUnit,
	dimensionUnit,
	setDimensionUnit,
	isAllStackable,
	setAllStackable,
	isAllTiltable,
	setAllTiltable,
	handleAddLineItem,
	setTotalPieces,
	error,
	setError,
	setTotalVolumeInMeters,
	setActualLooseTotalVolume,
	setTotalWeightInKg,
	totalWeightInKilo,
	totalVolumeinMtrs,
	setChargeableWeight,
	calculatedTotalWeight,
	setCalculatedTotalWeight,
	showValidation,
	disableWeightUnit,
	hideLooseUpload,
	draftCallback,
	excludeTon,
	captureAwb,
	isMultipleBookingEdit,
}) => {

	const [t, i18n] = useTranslation(['labels', 'errors'])

	const [weightWarning, setWeightWarning] = useState(null)

	const [showOpWeight, setShowOpweight] = useState(false)

	const [showFileUpload, setShowFileUpload] = useState(false);

	useEffect(() => {
		handleSummaryChange(looseDetails)
		handleWeightInput(looseDetails)
	}, [looseDetails, weightUnit, dimensionUnit, totalWeight])

	useEffect(() => {
		let chargeableWeight = 0
		let volumetricWeight = 0
		if (totalVolumeinMtrs) {
			//volumetricWeight = round(totalVolumeinMtrs, 2) * 166.6667
			volumetricWeight = Number(totalVolumeinMtrs).toFixed(2) * 166.6667
		}
		if (totalWeightInKilo || volumetricWeight) {
			chargeableWeight = Math.max(totalWeightInKilo * 1, volumetricWeight * 1)
		}
		setChargeableWeight(chargeableWeight)
	}, [totalVolumeinMtrs, totalWeightInKilo])

	useEffect(() => {
		setLooseItemsGrossWeight(calculatedTotalWeight)
		const weight = calculatedTotalWeight ? calculatedTotalWeight : totalWeight
		const totalWeightinKg = calculateWeightToKg(weight, weightUnit)
		setTotalWeightInKg(totalWeightinKg)
		if (draftCallback) {
			draftCallback(true)
		}
	}, [totalWeight, calculatedTotalWeight, weightUnit])

	const handleItemChange = (key, value, index) => {
		const templooseDetails = JSON.parse(JSON.stringify(looseDetails))
		if (key == 'stackable' || key == 'turnable') {
			templooseDetails[index][key] = !value
		} else {
			templooseDetails[index][key] = value
		}
		setLooseDetails([...templooseDetails])
		if (key == 'weightType') {
			handleWeightInput(templooseDetails)
		}
	}

	const handleWeightInput = (LooseDetails) => {
		const calculatedTotalWeight = [...LooseDetails, {}].reduce((curr, next) => {
			return {
				weight:
					(curr.weightType === DETAILS_APPLY_FOR.PER_ITEM
						? (curr.pieces ? curr.pieces * 1 : 0) *
						(curr.weight ? curr.weight * 1 : 0)
						: curr.weight
							? curr.weight * 1
							: 0) +
					(next.weightType === DETAILS_APPLY_FOR.PER_ITEM
						? (next.pieces ? next.pieces * 1 : 0) *
						(next.weight ? next.weight * 1 : 0)
						: next.weight
							? next.weight * 1
							: 0),
				pieces: 1,
			}
		}).weight
		if (showValidation) {
			let totalWeightError = validateTotalWeight(
				totalWeight,
				calculatedTotalWeight
			)
			setError({ ...error, [FORM_FIELDS.TOTAL_WEIGHT]: totalWeightError })
		}
		// setWeightWarning(
		// 	validateLineItemWeightSum(calculatedTotalWeight, totalWeight)
		// )
		setCalculatedTotalWeight(calculatedTotalWeight)
	}

	const handleLineItemWeightRemoval = () => {
		let looseDetailsErrors =
			error && error[FORM_FIELDS.LOOSE_ITEMS]
				? error[FORM_FIELDS.LOOSE_ITEMS]
				: []
		looseDetailsErrors = validateLineItemWeights(
			looseDetails,
			looseDetailsErrors
		)
		setError({ ...error, [FORM_FIELDS.LOOSE_ITEMS]: looseDetailsErrors })
	}

	const handleSummaryChange = (LooseDetails) => {
		let quantity = 0
		let totalVolumeinMeters = 0
		let actualTotalVolume = 0
		LooseDetails.forEach(function (element) {
			if (element.pieces) {
				quantity += element.pieces * 1
			}
			if (element.pieces && element.length && element.width && element.height) {
				actualTotalVolume +=
					parseFloat(element.width * element.length * element.height) *
					parseInt(element.pieces)
			}
			if (element.pieces && element.length && element.width && element.height) {
				if (dimensionUnit == DIMENSION_UNIT.INCHES) {
					totalVolumeinMeters +=
						parseFloat(
							element.width *
							0.0254 *
							(element.length * 0.0254) *
							(element.height * 0.0254)
						) * parseInt(element.pieces)
				}
				if (dimensionUnit == DIMENSION_UNIT.CENTIMETERS) {
					totalVolumeinMeters +=
						parseFloat(
							element.width *
							0.01 *
							(element.length * 0.01) *
							(element.height * 0.01)
						) * parseInt(element.pieces)
				}
			}
		})
		if (totalVolumeinMeters && totalVolumeinMeters < 0.01) {
			totalVolumeinMeters = 0.0
		}
		setTotalVolumeInMeters(totalVolumeinMeters)
		setActualLooseTotalVolume(actualTotalVolume)
		setTotalPieces(quantity)
	}
	const handleRemoveItem = (index) => {
		const looseDetailsTemp = looseDetails.filter((itemDetail, curr) => {
			return index !== curr
		})
		setLooseDetails(looseDetailsTemp)
		handleWeightInput(looseDetailsTemp)
		let looseDetailsErrors = validateLooseDetails(looseDetailsTemp)
		const hasError = looseDetailsErrors.some((item) => (item ? true : false))
		error[FORM_FIELDS.LOOSE_ITEMS] = hasError ? looseDetailsErrors : null
	}

	const clearError = (key) => {
		const tempError = error ? { ...error } : null
		if (tempError) {
			tempError[key] = null
			setError(tempError)
		}
	}
	const clearItemError = (key, index) => {
		const tempError = error ? { ...error } : null
		if (
			tempError &&
			tempError[FORM_FIELDS.LOOSE_ITEMS] &&
			tempError[FORM_FIELDS.LOOSE_ITEMS][index]
		) {
			tempError[FORM_FIELDS.LOOSE_ITEMS][index][key] = null
			setError(tempError)
		}
	}

	const handleClickAdd = (e) => {

		const tempCalculatedSumError =
			totalWeight && calculatedTotalWeight * 1 == totalWeight * 1
				? 'Sum of dimension level weight(s) cannot exceed the Total weight.'
				: weightWarning
		handleAddLineItem(e)
		// setTimeout(() => {
		// 	setWeightWarning(tempCalculatedSumError)
		// }, 300)
	}
	//============== for bulk upload ===============//
	const isEmpty = looseDetails?.map((item) => {
		if (
			item.pieces === '' &&
			item.length === '' &&
			item.height === '' &&
			item.stackable === true &&
			item.turnable === true &&
			item.weight === '' &&
			item.weightType === 'PER_ITEM' &&
			item.width === ''
		) {
			return true
		} else return false
	})

	const checkIsEmpty = () => {
		let isLooseEmpty = true
		looseDetails?.filter((item) => {
			if (
				item.pieces !== '' ||
				item.length !== '' ||
				item.height !== '' ||
				item.weight != '' ||
				item.width != '' ||
				item.weightType !== 'PER_ITEM'
			) {
				isLooseEmpty = false
			}
		})
		return isLooseEmpty;
	}

	const onReadExcel = (val, weightUnit, dimensionUnit) => {
		//============== for bulk dimension & weight unit ===============//
		if (dimensionUnit === 'cm') {
			setDimensionUnit('C')
		} else if (dimensionUnit === 'inch') {
			setDimensionUnit('I')
		} else return

		if (weightUnit === 'kg') {
			setWeightUnit('K')
		} else if (weightUnit === 'lb') {
			setWeightUnit('L')
		} else if (weightUnit === 't') {
			setWeightUnit('T')
		} else return
		//=================================================//
		let tempLooseDetails = [...looseDetails]
		if (captureAwb) {
			tempLooseDetails = []
		}

		if (checkIsEmpty()) {
			tempLooseDetails = val
			setLooseDetails(val)
		} else {
			tempLooseDetails = tempLooseDetails.concat(val)
			setLooseDetails(tempLooseDetails)
		}
		let looseDetailsErrors = validateLooseDetails(tempLooseDetails)
		const hasError = looseDetailsErrors.some((item) => (item ? true : false))
		error[FORM_FIELDS.LOOSE_ITEMS] = hasError ? looseDetailsErrors : null
	}
	//==============================================//

	useEffect(() => {
		if (isAllStackable === undefined) {
			setAllStackable(false)
		}
		if (isAllTiltable === undefined) {
			setAllTiltable(false)
		}
	}, [isAllTiltable, isAllStackable])

	/*=================== OPERATIONAL WEIGHT=========================*/

	const handleOperationalWeight = () => {
		setShowOpweight(!showOpWeight)
	}


	return (
		<>
			{looseDetails &&
				looseDetails.length &&
				looseDetails.map((item, key) => {
					const piecesError =
						error &&
							error[FORM_FIELDS.LOOSE_ITEMS] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.PIECES]
							? error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.PIECES]
							: null
					const lengthError =
						error &&
							error[FORM_FIELDS.LOOSE_ITEMS] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.LENGTH]
							? error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.LENGTH]
							: null
					const widthError =
						error &&
							error[FORM_FIELDS.LOOSE_ITEMS] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.WIDTH]
							? error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.WIDTH]
							: null
					const heightError =
						error &&
							error[FORM_FIELDS.LOOSE_ITEMS] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.HEIGHT]
							? error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.HEIGHT]
							: null
					const weightError =
						error &&
							error[FORM_FIELDS.LOOSE_ITEMS] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.WEIGHT]
							? error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.WEIGHT]
							: null
					return (
						<div
							className={`cargo-dimensions-row  ${looseDetails.length - 1 === key ? 'last-item' : ''
								}`}
							key={key}
						>
							<div className='form-row-dimensions mb-0'>
								<div
									className={`form-group ${piecesError ? "red-border" : ""
										}`}
								>
									<CommonInput
										type='text'
										label={t('COMMON.PCS')}
										value={item.pieces}
										id={`quantity-${key}`}
										onChange={(e) => {
											const value = e.target.value.replace(/[^\d]/, '');
											if (value.length <= 5) {
												handleItemChange('pieces', value, key)
											}
										}}
										onFocus={(e) =>
											clearItemError(LOOSE_FORM_FIELDS.PIECES, key)
										}
										onBlur={(e) => {
											if (!Number(item.pieces)) {
												handleItemChange('pieces', '', key)
											}
											handleWeightInput(looseDetails)
										}}
										error={piecesError ? t(piecesError, { ns: 'errors' }) : ''}
									/>
								</div>
								<div
									className={`form-group  ${lengthError ? "red-border" : ""
										}`}
								>
									<CommonInput
										type='text'
										label={t('COMMON.LN')}
										value={item['length']}
										id={`length-${key}`}
										onChange={(e) => {
											const value = e.target.value.replace(/[^\d]/, '');
											if (value.length <= 5) {
												handleItemChange('length', value, key)
											}
										}}
										onFocus={(e) =>
											clearItemError(LOOSE_FORM_FIELDS.LENGTH, key)
										}
										onBlur={(e) => {
											if (!Number(item['length'])) {
												handleItemChange('length', '', key)
											}
											handleSummaryChange(looseDetails)
										}}
										error={lengthError ? t(lengthError, { ns: 'errors' }) : ''}
									/>
								</div>

								<div
									className={`form-group ${widthError ? "red-border" : ""
										}`}
								>
									<CommonInput
										type='text'
										label={t('COMMON.WD')}
										id={`width-${key}`}
										value={item.width}
										onChange={(e) => {
											const value = e.target.value.replace(/[^\d]/, '');
											if (value.length <= 5) {
												handleItemChange('width', value, key)
											}
										}}
										onFocus={(e) =>
											clearItemError(LOOSE_FORM_FIELDS.WIDTH, key)
										}
										onBlur={(e) => {
											if (!Number(item['width'])) {
												handleItemChange('width', '', key)
											}
											handleSummaryChange(looseDetails)
										}}
										error={widthError ? t(widthError, { ns: 'errors' }) : ''}
									/>
								</div>
								<div
									className={`form-group ${heightError ? 'red-border' : ''
										}`}
								>
									<CommonInput
										type='text'
										label={t('COMMON.HT')}
										id={`height-${key}`}
										value={item.height}
										onChange={(e) => {
											const value = e.target.value.replace(/[^\d]/, '');
											if (value.length <= 5) {
												handleItemChange('height', value, key)
											}
										}}
										onFocus={(e) =>
											clearItemError(LOOSE_FORM_FIELDS.HEIGHT, key)
										}
										onBlur={(e) => {
											if (!Number(item.height)) {
												handleItemChange('height', '', key)
											}
											handleSummaryChange(looseDetails)
										}}
										error={heightError ? t(heightError, { ns: 'errors' }) : ''}
									/>
								</div>
								<CommonDropDown
									label={t("COMMON.UNIT_TYPE")}
									className={'uld-dimension-unit-dropdown'}
									value={dimensionUnit}
									options={DIMENSION_UNIT_SELECT_ITEMS}
									onChange={(e) => setDimensionUnit(e.target.value)}
									disabled={key ? true : false}
									dataKey={item.dimensionUnit}
								/>
							</div>
							<div className="form-row-weight">
								<div className='wght-left-section'>
									<div
										className={`form-group input-with-dropdown`}
									>
										<CommonInput
											type='text'
											label={t('COMMON.WT_OPT')}
											value={item.weight}
											onKeyDown={(evt) => allowNumberOnly(evt)}
											onChange={(e) => {
												const value = e.target.value.replace(/[^0-9.]/g, '');
												if (value.length <= 9 && (
													!value.split('.')[1] ||
													!value.split('.')[1].length ||
													value.split('.')[1].length < 2
												) &&
													(value.split('.').length <= 2)
												) {
													handleItemChange('weight', value, key)
												}
											}}
											onFocus={(e) =>
												clearItemError(LOOSE_FORM_FIELDS.WEIGHT, key)
											}
											onBlur={(e) => {
												handleWeightInput(looseDetails)
												if (
													(!e.target.value || !e.target.value.length) &&
													!looseDetails.some((detail) => detail.weight)
												) {
													handleLineItemWeightRemoval()
												}
											}}
											error={weightError ? t(weightError, { ns: 'errors' }) : ''}
										/>
										<CommonDropDown
											value={weightUnit}
											options={excludeTon ? WEIGHT_UNIT_SELECT_ITEMS_WO_TON : WEIGHT_UNIT_SELECT_ITEMS}
											onChange={(e) => {
												setWeightUnit(e.target.value)
												if (draftCallback) {
													draftCallback(true)
												}
											}}
											disabled={disableWeightUnit || key ? true : false}
											id='uld-weight-unit-dropdown'
											error={weightError}
											isNoLabel
										/>
									</div>

									<div className="form-group weight-type w-auto">
										<label className='sub-head-label'>{t("COMMON.WT_TYPE")}</label>
										<RadioToggle
											checkedArray={[item.weightType === DETAILS_APPLY_FOR.PER_ITEM, item.weightType === DETAILS_APPLY_FOR.TOTAL]}
											valueArray={[DETAILS_APPLY_FOR.PER_ITEM, DETAILS_APPLY_FOR.TOTAL]}
											labelArray={["COMMON.PER_ITEM", "COMMON.TOTAL"]}
											className={`uld-weight-type-toggle-${key}`}
											onChangeArray={[(e) => {
												handleItemChange('weightType', e.target.value, key)
											},
											(e) => {
												handleItemChange('weightType', e.target.value, key)
												handleWeightInput(looseDetails)
												handleSummaryChange(looseDetails)
											}]}
										/>
									</div>
									<div className="form-group packing-type w-auto">
										<label className='sub-head-label'>{t("COMMON.PCKG_TYPE")}</label>
										<div className="chkbox-session">
											<div className="l-checkbox">
												<input
													id={`stackable-${key}`}
													type='checkbox'
													disabled={isAllStackable}
													checked={!item.stackable}
													onChange={(e) =>
														handleItemChange('stackable', e.target.checked, key)
													}
												/>
												<label className="mb-0" htmlFor={`stackable-${key}`}>
													{t('COMMON.NON_STACKABLE')}
												</label>
											</div>
											<div className="l-checkbox">
												<input
													id={`turnable-${key}`}
													type='checkbox'
													disabled={isAllTiltable}
													checked={!item.turnable}
													onChange={(e) =>
														handleItemChange('turnable', e.target.checked, key)
													}
												/>
												<label className="mb-0" htmlFor={`turnable-${key}`}>
													{t('COMMON.NON_TILTABLE')}
												</label>
											</div>
										</div>
									</div>
								</div>
								<div className='wght-right-section'>
									{looseDetails.length > 1 ? (
										<div className='delete-section ml-auto mt-auto' onClick={(e) => handleRemoveItem(key)}>
											<img src={deleteIcon} alt="Trash" title="Trash" id='Trash-icon' />
											<span>{t("COMMON.DELETE")}</span>
										</div>
									) : (
										<></>
									)}
								</div>
							</div>
						</div>
					)
				})}
			<>
				{showFileUpload && <FileUpload onRead={onReadExcel} closeButtonClick={() => setShowFileUpload(false)} pageName={captureAwb ? 'CAPTURE' : null} />}
				{!isMultipleBookingEdit && (
                        <div className="cargo-addupload-row  mb-0">
                            <div className="add-more-btn" onClick={(e) => handleClickAdd(e)}>
                                <img className='add-more-plus' src={plusIcon} alt='plus' title='add-more-plus' />
                                <a className="add-more-link">
                                    <span>{`${t('COMMON.ADD_ANOTHER')}`}</span>
                                </a>
                            </div>
                            {!hideLooseUpload && (
                                <>
                                    <label className='or-label'>{t("COMMON.OR")}</label>
                                    <div className="add-more-btn" onClick={() => setShowFileUpload(true)}>
                                        <img className='upload-icon' src={uploadIcon} alt='upload' title='upload-icon' />
                                        <a className="add-more-link">
                                            <span>{`${t('BOOKING.UPLOAD')}`}</span>
                                        </a>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
			</>
		</>
	)
}

export default LooseLineItem
